import { Navigate, Route, Routes } from 'react-router-dom';
import { ProgressProvider } from './ProgressContext';
import { useAuth } from './AuthContext';
import { AppShell } from '../components/AppShell';
import { LandingPage } from '../pages/LandingPage';
import { AuthPage } from '../pages/AuthPage';
import { DashboardPage } from '../pages/DashboardPage';
import { RoadmapPage } from '../pages/RoadmapPage';
import { DayPage } from '../pages/DayPage';
import { ProgressPage } from '../pages/ProgressPage';
import { RevisionPage } from '../pages/RevisionPage';
import { InterviewsPage } from '../pages/InterviewsPage';
import { MoveUpRight } from 'lucide-react';

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="boot"><span className="logo-mark"><MoveUpRight /></span><strong>ETAtoOffer</strong><small>Know your ETA. Earn your offer.</small><div className="boot-line" /></div>;
  }

  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to="/dashboard" replace /> : <LandingPage />} />
      <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <AuthPage mode="login" />} />
      <Route path="/register" element={user ? <Navigate to="/dashboard" replace /> : <AuthPage mode="register" />} />
      <Route path="/*" element={user ? (
        <ProgressProvider>
          <AppShell>
            <Routes>
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="roadmap" element={<RoadmapPage />} />
              <Route path="revision" element={<RevisionPage />} />
              <Route path="interviews" element={<InterviewsPage />} />
              <Route path="day/:day" element={<DayPage />} />
              <Route path="progress" element={<ProgressPage />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </AppShell>
        </ProgressProvider>
      ) : <Navigate to="/" replace />} />
    </Routes>
  );
}
